import React, { Component } from "react";
import { Polyline } from "@vis.gl/react-google-maps";
import { connect } from "react-redux";

import {
  ADD_WAYPOINT,
  CLEAR_SELECTING
} from "../../../reducers/map";


// {{ lat: -34.397, lng: 150.644 }}

class WpPolyline extends Component {
 
  state = {
    isMouseOver: false
  };

  addWaypoint = e => {
    let new_waypoint = {
      id: this.props.id,
      position: { lat: e.latLng.lat(), lng: e.latLng.lng() }
    };
    // this.props.CLEAR_SELECTING();
    this.props.ADD_WAYPOINT(new_waypoint);

  };



  onMouseOver = e => {
    this.setState({ isMouseOver : true })

  };

  onMouseOut = e => {
    this.setState({ isMouseOver : false })

  };


  render() {
    const id = this.props.id;
    let isMoving = false;

    if (
      this.props.marker_MovingAdding === id ||
      this.props.marker_MovingAdding === id + 1
    ) {
      isMoving = true;
    }

    let strokeWeight = 4;
    if (this.state.isMouseOver === true) {
      strokeWeight = 7;

    } else {
      strokeWeight = 4;

    }

    const normalSymbol = {
      strokeColor: "#1E90FF",
      strokeOpacity: 1,
      strokeWeight: strokeWeight,
      icons: []
    };

    const higlightSymbol = {
      strokeColor: "red",
      strokeOpacity: 0.8,
      strokeWeight: strokeWeight,
      icons: []
    };

    const option = isMoving ? higlightSymbol : normalSymbol;

    // White casing drawn underneath the colored route to make it stand out
    // against the map. Wider than the route and not clickable so it never
    // intercepts hover/click events meant for the route on top.
    const whiteCasing = {
      zIndex: -1,
      strokeColor: "#FFFFFF",
      strokeOpacity: 1,
      strokeWeight: strokeWeight + 4,
      clickable: false,
      icons: []
    };

    return (
      <React.Fragment>
        <Polyline
          path={this.props.path}
          {...whiteCasing}
        />
        <Polyline
          path={this.props.path}
          {...option}
          onClick={this.addWaypoint}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    marker_selecting: state.map.marker_selecting,
    marker_MovingAdding: state.map.marker_MovingAdding,
    // paths: state.paths
  };
};

const mapActionsToProps = {
  // CIRCLE_SELECTING : mapSelectedCircle ,
  // CIRCLE_CHANGE : mapChangeCircle ,
  ADD_WAYPOINT : ADD_WAYPOINT,
  CLEAR_SELECTING: CLEAR_SELECTING
};

// const mapDispatchToProps = dispatch => {
//   return {
//     MARKER_SELECTING: id => dispatch({ type: "MARKER_SELECTING", value: id }),
//     MARKER_MOVE: id => dispatch({ type: "MARKER_MOVE", value: id }),
//     ADD_WAYPOINT: w => dispatch({ type: "ADD_WAYPOINT", value: w })
//   };
// };

export default connect(
  mapStateToProps,
  mapActionsToProps
)(WpPolyline);
